<template>
  <section :class="[loadingClass, 'cart']">
    <div class="loading-icon" />

    <div class="order-items">
      <OrderItem
        v-for="item in order.items"
        :key="item.id"
        :cartversion="order.cart_version"
        :item="item"
      />
    </div>

    <CurrencySelection
      :chargecurrency="order.charge_currency"
      :chargeablecurrencies="order.chargeable_currencies"
    />

    <DiscountForm :activediscounts="order.active_discounts" />

    <AmountDisplay
      v-if="order.discount > 0"
      extraclass="discount"
      :header="$t(&quot;formPackage.discount&quot;)"
      :amount="&quot;(&quot; + order.discount_decorated + &quot;)&quot;"
    />

    <AmountDisplay
      v-if="order.h4h_points > 0"
      extraclass="h4h-program"
      :header="order.h4h_program"
      :amount="&quot;(&quot; + order.h4h_points_decorated + &quot;)&quot;"
    />

    <AmountDisplay
      v-if="order.tax > 0"
      extraclass="tax"
      :header="$t(&quot;cart.tax&quot;)"
      :amount="order.tax_decorated"
    />

    <AmountDisplay
      v-if="order.vat_tax > 0"
      extraclass="vat-tax"
      :header="$t(&quot;cart.vatTax&quot;)"
      :amount="order.vat_tax_decorated"
    />

    <AmountDisplay
      extraclass="fee"
      :header="$t(&quot;cart.processingFee&quot;)"
      :amount="order.processing_fee_decorated"
    />

    <AmountDisplay
      extraclass="fee-and-tax"
      :header="$t(&quot;cart.processingFeeTax&quot;)"
      :amount="order.fee_and_tax_decorated"
    />


    <div class="total-charge">
      <AmountDisplay
        extraclass="total"
        :header="$t(&quot;cart.yourTotal&quot;)"
        :amount="order.total_decorated"
      />

      <CurrencyDisclaimer
        :currency="order.charge_currency"
        :chargeablecurrencies="order.chargeable_currencies"
      />
    </div>

    <div class="total-exchange">
      <AmountDisplay
        extraclass="total"
        :header="$t(&quot;cart.yourTotal&quot;)"
        :amount="order.total_exchange_decorated"
      />

      <CurrencyDisclaimer
        :currency="order.currency"
        :chargeablecurrencies="order.chargeable_currencies"
      />
    </div>




    <PaymentTermForm
      v-if="hasPaymentTerms"
      :options="order.event_payment_term_options"
      :orderpaymentcount="order.payment_count"
    />

    <div
      v-if="hasPaymentTerms"
      class="payment-terms"
    >
      <PaymentTermDisplay
        v-for="(term, i) in order.payment_terms"
        :key="term.id"
        :currency="order.charge_currency"
        :index="i+1"
        :term="term"
      />
    </div>
  </section>
</template>

<script>
import AmountDisplay from './amount_display'
import CurrencyDisclaimer from '../../default/currency_convert/currency-disclaimer'
import CurrencySelection from './currency_selection'
import DiscountForm from './discount_form'
import OrderItem from './order_items/order_item'
import PaymentTermDisplay from './payment_terms/term_display'
import PaymentTermForm from './payment_terms/term_form'

export default {
  components: {
    AmountDisplay,
    CurrencyDisclaimer,
    CurrencySelection,
    DiscountForm,
    OrderItem,
    PaymentTermDisplay,
    PaymentTermForm
  },

  props: ['order', 'loading'],
  computed: {
    hasPaymentTerms() {
      return !(this.order.event_payment_term_options.slice(-1)[0] == 1)
    },

    loadingClass() {
      return (this.loading ? 'loading' : '')
    },
  }
}
</script>
